import User, { USER_STORAGE_KEY_MAP } from 'shared/storage/user';
import { getSearchWidgetInstance } from 'client/javascript/pages/shared/sections/hero_container/search_widget';
import { TEAMS } from 'shared/rollbar/global_prefixes';
import { logError } from 'client/javascript/util/logger';

export const LOGGING_CONFIG = {
  prefix: '[SearchWidgetWorkspaceTypeFilterUI]',
  team: TEAMS.MARKETING
};

export const FILTER_NAME = 'workspace_type';

export const CLASSES = {
  MODULE_ACTIVE_CARD: 'workspace-type-filter__card--active'
};

export const SELECTORS = {
  MODULE_DROPDOWN: '[data-dropdown-name="workspace_type"]',
  MODULE_CARD: '.workspace-type-filter__card',
  MODULE_CARD_TITLE: '.workspace-type-filter__card-title'
};

export function setupWorkspaceTypeFilter(domNode) {
  try {
    const dropdownDomNode = domNode.querySelector(SELECTORS.MODULE_DROPDOWN);
    const workspaceTypeCards = dropdownDomNode.querySelectorAll(SELECTORS.MODULE_CARD);
    const workspaceTypeDataFromLocalStorage = User.getValue(USER_STORAGE_KEY_MAP.workspace);
    const searchWidgetInstance = getSearchWidgetInstance();

    if (workspaceTypeDataFromLocalStorage) {
      applyWorkspaceDataFromLocalStorage({
        dropdownDomNode,
        workspaceTypeCards,
        searchWidgetInstance,
        workspaceTypeDataFromLocalStorage
      });
    }

    setupWorkspaceTypeCards(workspaceTypeCards, searchWidgetInstance);
  } catch (error) {
    logError(`${LOGGING_CONFIG.prefix}[setupWorkspaceTypeFilter()] failed to setup workspace type cards`, error, {
      team: LOGGING_CONFIG.team
    });
  }
}

function setupWorkspaceTypeCards(workspaceTypeCards, searchWidgetInstance) {
  workspaceTypeCards.forEach((card) => {
    card.addEventListener('click', ({ currentTarget }) => {
      const { workspaceType } = currentTarget.dataset;
      const cardTitleDomNodeInnerText = currentTarget.querySelector(SELECTORS.MODULE_CARD_TITLE).innerText;

      toggleWorkspaceTypeCardClasses(workspaceTypeCards, workspaceType);
      searchWidgetInstance.setFilterValue(FILTER_NAME, cardTitleDomNodeInnerText);
      User.saveValue(USER_STORAGE_KEY_MAP.workspace, workspaceType);
      searchWidgetInstance.setupFiltersItemsTrackingEvent(FILTER_NAME, cardTitleDomNodeInnerText);
      searchWidgetInstance.updateSearchUrl(USER_STORAGE_KEY_MAP.workspace, workspaceType);
    });
  });
}

function applyWorkspaceDataFromLocalStorage({
  dropdownDomNode,
  workspaceTypeCards,
  searchWidgetInstance,
  workspaceTypeDataFromLocalStorage
}) {
  const cardTitleDomNode = dropdownDomNode.querySelector(
    `[data-workspace-type=${workspaceTypeDataFromLocalStorage}] ${SELECTORS.MODULE_CARD_TITLE}`
  );

  if (cardTitleDomNode) {
    toggleWorkspaceTypeCardClasses(workspaceTypeCards, workspaceTypeDataFromLocalStorage);
    searchWidgetInstance.setFilterValue(FILTER_NAME, cardTitleDomNode.textContent);
    searchWidgetInstance.updateSearchUrl(USER_STORAGE_KEY_MAP.workspace, workspaceTypeDataFromLocalStorage);
  }
}

function toggleWorkspaceTypeCardClasses(workspaceTypeCards, workspaceTypeDataFromLocalStorage) {
  workspaceTypeCards.forEach((card) => {
    card.classList.remove(CLASSES.MODULE_ACTIVE_CARD);

    if (card.dataset.workspaceType === workspaceTypeDataFromLocalStorage) {
      card.classList.add(CLASSES.MODULE_ACTIVE_CARD);
    }
  });
}
